var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.7a806a8e75dbd713abb4ce733fa219d3.svg#N';
                    var viewUrl = 'sprites.7a806a8e75dbd713abb4ce733fa219d3.svg#view-N';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 21 19',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };